<template>
    <div>
        <button :class="[buttonClass]" @click="show">
            {{ $t('account.change.password') }}
        </button>
        <modal v-if="showChangePassword" type="custom">
            <div class="text-lg sm:m-4">
                <h3 class="text-xl font-black mb-4">
                    {{ $t('account.change.password') }}
                </h3>
                <formFieldRow
                    name="currentPassword"
                    :label="$t('account.current.password')"
                    :errors="errors"
                    v-if="hasCustLgnPwd"
                >
                    <template #default="{hasError}">
                        <input
                            class="form-input"
                            :class="{ 'border-red': hasError }"
                            type="password"
                            v-model.trim="form.currentPassword"
                        />
                    </template>
                </formFieldRow>
                <formFieldRow
                    name="newPassword"
                    :label="$t('account.new.password')"
                    :errors="errors"
                >
                    <template #default="{hasError}">
                        <div class="flex flex-col sm:flex-col-reverse">
                            <div class="text-sm text-darkGrayishBlue">
                                {{ $t('login.password.hint') }}
                            </div>
                            <input
                                class="form-input"
                                :class="{ 'border-red': hasError }"
                                type="password"
                                v-model.trim="form.newPassword"
                            />
                        </div>
                    </template>
                </formFieldRow>
                <formFieldRow
                    name="confirmNewPassword"
                    :label="$t('account.confirm.new.password')"
                    :errors="errors"
                >
                    <template #default="{hasError}">
                        <input
                            class="form-input"
                            :class="{ 'border-red': hasError }"
                            type="password"
                            v-model.trim="form.confirmNewPassword"
                        />
                    </template>
                </formFieldRow>
            </div>
            <div class="flex mt-8 justify-end sm:m-4 sm:mt-8">
                <button
                    class="flex-grow btn btn-white py-2 text-xl justify-center sm:flex-grow-0 sm:px-16 sm:ml-4"
                    @click="hide"
                    :disabled="!!saveStatus"
                >
                    {{ $t('common.cancel') }}
                </button>
                <loadingButton
                    class="flex-grow btn btn-primary text-xl py-2 ml-4 bg-primary font-black justify-center sm:flex-grow-0 sm:px-16"
                    :status="saveStatus"
                    @click="save"
                    @successShown="hide"
                >
                    {{ $t('common.save') }}
                </loadingButton>
            </div>
        </modal>
    </div>
</template>

<script>
import loadingButton from '@/components/loadingButton.vue';
import modal from '@/components/modal.vue';
import formFieldRow from '@/components/formFieldRow.vue';
import { instance } from '@/utils/ajax';
import { validate, isValidPassword } from '@/utils/validationUtil';

async function changePassword(form) {
    try {
        let result = await instance.post(
            '/api/accountInfo/changePassword',
            form
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error register');
        return { success: false, all: 'error.connect' };
    }
}
export default {
    components: { loadingButton, modal, formFieldRow },
    props: {
        buttonClass: {
            default:
                'text-secondary underline hover:text-red focus:outline-none'
        }
    },
    data() {
        return {
            showChangePassword: false,
            form: {
                currentPassword: undefined,
                newPassword: undefined,
                confirmNewPassword: undefined
            },
            saveStatus: undefined,
            errors: {}
        };
    },
    computed: {
        hasCustLgnPwd() {
            return this.$store.state.user.hasCustLgnPwd;
        }
    },
    methods: {
        show() {
            this.showChangePassword = true;
            this.clearForm();
        },
        hide() {
            this.showChangePassword = false;
            this.clearForm();
        },
        clearForm() {
            this.form = {
                currentPassword: undefined,
                newPassword: undefined,
                confirmNewPassword: undefined
            };
            this.saveStatus = undefined;
            this.errors = {};
        },
        async save() {
            this.errors = {};
            const v = validate(this.errors, this.form, {
                currentPassword: { required: this.hasCustLgnPwd },
                newPassword: {
                    required: true,
                    passwordPattern: function(v) {
                        if (!isValidPassword(v)) {
                            return 'error.password.format';
                        }
                    }
                },
                confirmNewPassword: {
                    required: true,
                    passwordSame: function(val, d) {
                        if (val !== d.newPassword) {
                            return 'account.error.confirm.new.password.not.equal';
                        }
                    }
                }
            });
            if (v.hasError) {
                this.errors = v.errors;
                return;
            }

            this.saveStatus = 'loading';
            const result = await changePassword(this.form);
            if (!result.success) {
                this.saveStatus = undefined;
                this.errors = result.data.errors;
            } else {
                this.saveStatus = 'success';
                this.$store.commit('setUser', result.data.user);
            }
        }
    }
};
</script>
